module.exports = __webpack_public_path__ + "static/blue-videogame@2x-1b3ee91833bb9aea3f8b25439a4d725b.svg";